import { ZIndexT } from "../types.js"

const zIndex: ZIndexT = {
  drawer: 100,
  header: 100,
  overlay: 100,
  modal: 200,
  select: 200,
  alert: 300,
  toast: 300,
}

export default zIndex
